import React, { useState, useEffect } from 'react';
import Result from './Result';
import ResultFiscal from './ResultFiscal';
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";

function Calculator() {
  const [paidBGN, setPaidBGN] = useState('');
  const [paidEUR, setPaidEUR] = useState('');
  const [dueEUR, setDueEUR] = useState('');
  const [exchangeRate, setExchangeRate] = useState(1.95583); // Default rate
  const [outputCurrency, setOutputCurrency] = useState("EUR");

  const [result, setResult] = useState(null);
  const [resultFiscal, setResultFiscal] = useState(null);

  
  useEffect(() => {
    calculateChange();
  }, [paidBGN, paidEUR, dueEUR, outputCurrency, exchangeRate]);

  const calculateChange = () => {
    
    const bgn = parseFloat((paidBGN || '').replace(',', '.')) || 0;
    const eur = parseFloat((paidEUR || '').replace(',', '.')) || 0;
    const due = parseFloat((dueEUR || '').replace(',', '.')) || 0;


    if (due === 0) {
      setResult(null);
      return;
    }

    const paidInEUR = (bgn / exchangeRate) + eur;
    const difference = paidInEUR - due;

    let message = '';
    let messageFiscal = ''
    if (difference < 0) {
      const owed = Math.abs(difference);
      message = 'Дължи: ' + (outputCurrency === 'BGN' ? (owed.toFixed(2) * exchangeRate).toFixed(2) + ' BGN или ' + owed.toFixed(2) + ' EUR' : owed.toFixed(2) + ' EUR или '+(owed.toFixed(2) * exchangeRate).toFixed(2) + ' BGN');
      messageFiscal = 'Фискален бон: ' + paidInEUR.toFixed(2) + ' EUR';
    } else if (difference > 0) {
      message = 'Ресто: ' +
        (outputCurrency === 'BGN' ? (difference.toFixed(2) * exchangeRate).toFixed(2) + ' BGN или ' + difference.toFixed(2) + ' EUR' : difference.toFixed(2) + ' EUR или '+(difference.toFixed(2) * exchangeRate).toFixed(2)  + ' BGN');
        messageFiscal = 'Фискален бон: ' + due.toFixed(2) + ' EUR';
    } else {
      message = 'Точно платена сума';
    }

    setResult(message);
    setResultFiscal(messageFiscal)
  };

  const resetFields = () => {
    setPaidBGN('');
    setPaidEUR('');
    setDueEUR('');
    setExchangeRate(1.95583);
    setResult(null);
    setResultFiscal(null);
    setOutputCurrency('EUR')
  };

  return (
    <div className="calculator-container">
      <div className="input-group">
        <label>Задължение (EUR):</label>
        
          <input
            type="text"
            inputMode="decimal" // Shows numeric keyboard on mobile
            value={dueEUR}
            onChange={(e) => {
              let value = e.target.value;

              // Replace comma with dot
              value = value.replace(',', '.');

              // Remove invalid characters (only digits and dot)
              value = value.replace(/[^0-9.]/g, '');

              // Prevent multiple dots
              const parts = value.split('.');
              if (parts.length > 2) {
                value = parts[0] + '.' + parts.slice(1).join('');
              }

              // Limit to 2 decimal places
              if (parts[1] && parts[1].length > 2) {
                value = parts[0] + '.' + parts[1].slice(0, 2);
              }

              // Ensure positive
              if (parseFloat(value) < 0) {
                value = '';
              }

              setDueEUR(value);
            }}
          />

      </div>
      <div className="input-group">
        <label>Платено в BGN:</label>
        
        <input
          type="text"
          inputMode="decimal" // Shows numeric keyboard on mobile
          value={paidBGN}
          onChange={(e) => {
            let value = e.target.value;

            // Replace comma with dot
            value = value.replace(',', '.');

            // Remove invalid characters (only digits and dot)
            value = value.replace(/[^0-9.]/g, '');

            // Prevent multiple dots
            const parts = value.split('.');
            if (parts.length > 2) {
              value = parts[0] + '.' + parts.slice(1).join('');
            }

            // Limit to 2 decimal places
            if (parts[1] && parts[1].length > 2) {
              value = parts[0] + '.' + parts[1].slice(0, 2);
            }

            // Ensure positive
            if (parseFloat(value) < 0) {
              value = '';
            }

            setPaidBGN(value);
          }}
        />

      </div>

      <div className="input-group">
        <label>Платено в EUR:</label>
        <input
          type="text"
          inputMode="decimal" // Shows numeric keyboard on mobile
          value={paidEUR}
          onChange={(e) => {
            let value = e.target.value;

            // Replace comma with dot
            value = value.replace(',', '.');

            // Remove invalid characters (only digits and dot)
            value = value.replace(/[^0-9.]/g, '');

            // Prevent multiple dots
            const parts = value.split('.');
            if (parts.length > 2) {
              value = parts[0] + '.' + parts.slice(1).join('');
            }

            // Limit to 2 decimal places
            if (parts[1] && parts[1].length > 2) {
              value = parts[0] + '.' + parts[1].slice(0, 2);
            }

            // Ensure positive
            if (parseFloat(value) < 0) {
              value = '';
            }

            setPaidEUR(value);
          }}
        />

      </div>

      <div className="input-group">
        <label>Валутен курс (BGN/EUR):</label>
        <input
          type="number"
          step="0.00001"
          value={exchangeRate}
          disabled='true'
          onChange={(e) => setExchangeRate(parseFloat(e.target.value) || 1.95583)}
        />
      </div>
          {resultFiscal && <ResultFiscal value={resultFiscal} />}
      
      <div className="button-group" style={{ display: "flex",justifyContent: "center",alignItems: "center"}}>
        <button onClick={resetFields} className="reset-btn">Нулиране</button>
      </div>

      {result && <Result value={result} />}
    </div>
  );
}

export default Calculator;
